import cx from 'classnames2';
import React from 'react';

import { useListTableContext } from '../ListTable';

import styles from './ListTable.HeaderCell.module.scss';

export interface IListTableHeaderCellProps {
  ariaLabel?: string;
  children?: any;
  style?: any;
  dataTest?: string;
}

export const ListTableHeaderCell: React.FC<IListTableHeaderCellProps> = ({ ariaLabel, children, dataTest, style }) => {
  const context = useListTableContext();

  return (
    <div
      aria-label={ariaLabel}
      style={style}
      className={cx(styles.headerCell, context.variant === 'condensed' && styles.variantCondensed)}
      data-test={dataTest}
    >
      {children}
    </div>
  );
};
